import React, { useState } from 'react';
import IconDots from '../../images/IconDots.jsx';
import dayjs from 'dayjs';
import IconClose from '../../images/IconClose.jsx';
import IconEdit from '../../images/IconEdit.jsx';
import IconMilestone from '../../images/IconMilestone.jsx';
import IconReport from '../../images/IconReport.jsx';
import ProjectMilestoneReportAddEdit from './ProjectMilestoneReportAddEdit.jsx';

const ProjectMilestoneReportListItem = ({ data, entityType, onDelete, onEdit }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editVisible, setEditVisible] = useState(false);

    const { id, title, description, date, type } = data;

    const status = {
        'to-do': { text: 'To-Do', color: 'bg-theme1-info' },
        'in-progress': { text: 'In Progress', color: 'bg-theme1-gold' },
        completed: { text: 'Completed', color: 'bg-theme1-success' }
    };

    const getStatus = (statusKey, date) => {
        const today = dayjs().startOf('day');
        const targetDate = dayjs(date).startOf('day');

        if (statusKey !== 'completed' && targetDate.isBefore(today)) {
            return { text: 'Overdue', color: 'bg-theme1-error' };
        }
        return status[statusKey] || 'Unknown';
    };

    const openDrawer = () => {
        setDrawerOpen(true);
    };

    const closeDrawer = () => {
        if (drawerOpen) {
            setDrawerOpen(false);
        }
    };

    const handleEdit = () => {
        closeDrawer();
        setEditVisible(true);
    };

    const handleDelete = () => {
        onDelete(id);
    };

    const handleSave = (updatedData) => {
        onEdit(id, updatedData);
        setEditVisible(false);
    };

    return (
        <>
            <div className='relative overflow-hidden mt-2'>
                <div className='flex flex-col max-w-3xl w-full mx-auto' onClick={closeDrawer}>
                    <div className='flex'>
                        <div
                            className={`rounded-full w-[48px] h-[48px] overflow-hidden mr-[16px] mt-2  flex items-center justify-center ${entityType.toLowerCase() === 'milestones' ? getStatus(type, date).color : 'bg-theme1-goldDark'}`}
                        >
                            {entityType.toLowerCase() === 'milestones' ? (
                                <IconMilestone className='fill-white w-6 h-6' />
                            ) : (
                                <IconReport className='fill-white w-6 h-6' />
                            )}
                        </div>
                        <div className='flex flex-1 items-center border-b border-solid border-theme1-tanTransparent pb-2'>
                            <div>
                                <div className='flex'>
                                    <h4 className='text-base text-theme1-title2 font-bold'>
                                        {title}
                                        {entityType.toLowerCase() === 'milestones' && (
                                            <span
                                                className={`ml-2 content px-2 py-[2px] rounded-md text-xs font-bold text-white capitalize mb-auto relative -top-[1px] ${getStatus(type, date).color}`}
                                            >
                                                {getStatus(type, date).text}
                                            </span>
                                        )}
                                    </h4>
                                </div>
                                {description && <p className='text-sm text-theme1-text2'>{description}</p>}

                                {date && (
                                    <p className='text-sm text-theme1-text3'>{dayjs(date).format('DD MMM YYYY')}</p>
                                )}
                            </div>
                            <button type='button' className='ml-auto' onClick={openDrawer}>
                                <IconDots className='fill-theme1-text1' />
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className={`absolute flex gap-[2px] top-0 right-0 h-full bg-white transform transition-transform duration-300 ${
                        drawerOpen ? 'translate-x-0 shadow-lg' : 'translate-x-full'
                    }`}
                >
                    <button
                        type='button'
                        className='w-[72px] flex-shrink-0 bg-theme1-primary py-2 rounded-[2px] flex items-center justify-center active:bg-theme1-brightRed'
                        onClick={handleEdit}
                    >
                        <IconEdit className='stroke-white w-[33px] h-[28px]' />
                    </button>

                    <button
                        type='button'
                        className='w-[72px] flex-shrink-0 bg-theme1-primary py-2 rounded-[2px] flex items-center justify-center active:bg-theme1-brightRed'
                        onClick={handleDelete}
                    >
                        <IconClose className='fill-white w-[38px] h-[33px]' />
                    </button>
                </div>
            </div>

            {editVisible && (
                <MemoizedProjectMilestoneReportAddEdit
                    addVisible={editVisible}
                    setAddVisible={setEditVisible}
                    onSave={handleSave}
                    type={entityType}
                    initialData={{ ...data }}
                />
            )}
        </>
    );
};

const MemoizedProjectMilestoneReportAddEdit = React.memo(ProjectMilestoneReportAddEdit);

export default ProjectMilestoneReportListItem;
